<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-credit-card"></i><ng-container>&nbsp;</ng-container
    ><ng-container i18n>Add Credit Card</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" class="row">
    <div class="col-sm-6">
      <mat-form-field2 class="mat-block">
        <input matInput placeholder="First Name:" i18n-placeholder formControlName="firstName" [required]="true" />
        <mat-error *ngIf="form.get('firstName').touched && form.get('firstName').hasError('required')">
          <ng-container i18n>First name is required</ng-container>
        </mat-error>
        <mat-error
          *ngIf="
            form.get('firstName').touched &&
            form.get('firstName').hasError('allWhitespace') &&
            !form.get('firstName').hasError('required')
          "
          i18n
        >
          First name cannot be all whitespaces
        </mat-error>
      </mat-form-field2>
    </div>
    <div class="col-sm-6">
      <mat-form-field2 class="mat-block">
        <input matInput placeholder="Last Name:" i18n-placeholder formControlName="lastName" [required]="true" />
        <mat-error *ngIf="form.get('lastName').touched && form.get('lastName').hasError('required')">
          <ng-container i18n>Last name is required</ng-container>
        </mat-error>
        <mat-error
          *ngIf="
            form.get('lastName').touched &&
            form.get('lastName').hasError('allWhitespace') &&
            !form.get('lastName').hasError('required')
          "
          i18n
        >
          Last name cannot be all whitespaces
        </mat-error>
      </mat-form-field2>
    </div>
    <div class="col-sm-12 cc-box">
      <app-stripe-credit-card-form #stripeCardForm></app-stripe-credit-card-form>
      <small *ngIf="stripeCardForm?.cardValidationMessage" class="text-danger">{{
        stripeCardForm.cardValidationMessage
      }}</small>
    </div>
    <div class="col-sm-12 terms-box">
      <mat-checkbox class="mt-primary mat-block" formControlName="terms" required>
        <ng-container i18n>I agree to the</ng-container><ng-container>&nbsp;</ng-container>
        <a href="https://www.tokeet.com/terms.html" target="_blank" i18n>terms & conditions</a
        ><sup class="text-danger">*</sup>
      </mat-checkbox>
      <mat-error i18n *ngIf="form.get('terms').touched && form.get('terms').hasError('required')">
        You have to accept terms and conditions
      </mat-error>
    </div>
    <div class="col-sm-12">
      <div class="terms">
        <p i18n>
          I authorise AdvanceCM to send instructions to the financial institution that issued my card to take payments
          from my card account in accordance with the terms of my agreement with you.
        </p>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button
    (click)="save(form)"
    [disabled]="processing || !stripeCardForm?.isCardValid"
    type="button"
    class="btn btn-secondary-info create-btn"
  >
    <i *ngIf="!processing" class="cs-icon cs-icon-save"></i>
    <i *ngIf="processing" class="far fa-spinner fa-spin"></i> <ng-container i18n>save</ng-container>
  </button>
</div>
